import { WorkflowRoleDto } from './../../../service/dto';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpWorkflowRoleService } from '../../../service/http-workflow-role.service';

@Component({
	selector: 'app-workflow-role-list',
	standalone: false,
	templateUrl: './workflow-role-list.component.html',
	styleUrl: './workflow-role-list.component.scss'
})
export class WorkflowRoleListComponent implements OnInit {
	data: WorkflowRoleDto[] = [];
	constructor(private httpService: HttpWorkflowRoleService, private router: Router) {
	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => {
			this.data = result.sort((a, b) => {
				const cmp = a.workflow!.label.localeCompare(b.workflow!.label);
				if (cmp !== 0) return cmp;
				return a.name!.localeCompare(b.name!);
			});
		});
	}



	add() {
		this.router.navigate(['/workflow_role', 'new']);
	}
	openWorkflowRole(input: WorkflowRoleDto) {
		this.router.navigate(['/workflow_role', input.id, 'edit']);
	}
}
